import { FC } from 'react';

const Page404: FC = () => {
  return <div>Page not found</div>;
};

export default Page404;
